import * as Swetrix from 'swetrix'

import {SWETRIX_API_URL, SWETRIX_PROJECT_ID} from '#/env'

/**
 * Initializes Swetrix page view analytics. No-ops unless both
 * `EXPO_PUBLIC_SWETRIX_PROJECT_ID` and `EXPO_PUBLIC_SWETRIX_API_URL` are set.
 */
export function init() {
  if (!SWETRIX_PROJECT_ID || !SWETRIX_API_URL) {
    return
  }

  Swetrix.init(SWETRIX_PROJECT_ID, {
    apiURL: SWETRIX_API_URL,
  })
  void Swetrix.trackViews()
}
